<template>
  <b-overlay :show="loading"
    spinner-variant="primary"
    spinner-type="grow">
    <div class="bg-white detail"
      v-if="Object.keys(dataItem).length > 0">
      <div class="row">
        <div class="col-12">
          <h1 v-if="lang == 'en'"> {{ dataItem.title_en }} </h1>
          <h1 v-else>{{ dataItem.title }}</h1>
          <div class="view"
            v-if="lang == 'en'"
            v-html="dataItem.content_en">
          </div>
          <div class="view"
            v-else
            v-html="dataItem.content">
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>

import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import { BButton, BOverlay, BIcon, BBadge } from 'bootstrap-vue'
export default {

  components: {
    BButton,
    BOverlay,
    BIcon,
    BBadge
  },
  props: {
    crawler_id: {
      type: Number,
      default: null
    },
    lang: {
      type: String,
      default: 'vi'
    }
  },
  setup(props, context) {
    const loading = ref(true)
    const dataItem = ref({});
    const lang = ref('');
    if (props.lang) {
      lang.value = props.lang
    }
    store.dispatch('crawler/show', props.crawler_id).then(response => {
      loading.value = false;
      let result = response.data;
      if (result.code == 200) {
        dataItem.value = result.data;
      }
    })
    return {
      dataItem,
      loading,
    }
  }
}
</script>